import { Component, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import {
	ContractConditionsServiceClickAcceptAction,
	ContractConditionsServiceDestroyAction,
	ContractConditionsServiceInitAction
} from '@shared/store/actions/contract-conditions-service-actions';
import {
	getContractConditionsPaymentText,
	getContractConditionsServiceHasError,
	getContractConditionsServiceMessage,
	getContractConditionsServiceText,
	getContractDataConditionsServiceAcceptedAt
} from '@spaq/core';
import { select, Store } from '@ngrx/store';
import { DialogService } from '@progress/kendo-angular-dialog';
import { ConditionsAcceptorComponent } from '@spaq/modules/utils/components';
import { take, tap } from 'rxjs/operators';

import { ServiceInfo } from '@spaq/utils';
import { ContractService } from '@shared/store';

@Component({
	selector: 'spaq-service-accept-conditions',
	template: `
		<spaq-message-state [hasError]="hasError$ | async" [message]="message$ | async"></spaq-message-state>
		<div class="mt-3">
			<input
				[(ngModel)]="isChecked"
				[checked]="acceptedAt$ | async"
				(change)="onAccept(isChecked)"
				type="checkbox"
				id="check_conditions"
				data-testid="service-accept-conditions"
				kendoCheckBox
			/>
			<label class="k-checkbox-label" for="check_conditions"
				>J'accepte les <a href="javascript://" data-testid="service-conditions-link" (click)="open()">conditions d'abonnement</a>
				<span *ngIf="service.serviceBillingType === 'DAS'"
					>et les<a href="javascript://" data-testid="service-payment-conditions-link" (click)="openPayment()">conditions de paiement</a></span
				></label
			>
		</div>
		<ng-container #container></ng-container>
	`,
	styles: [
		`
			a {
				padding: 0 4px;
			}
		`
	]
})
export class ServiceAcceptConditionsComponent implements OnInit, OnDestroy {
	@ViewChild('container', { read: ViewContainerRef })
	public containerRef: ViewContainerRef;
	acceptedAt$ = this.store.pipe(
		select(getContractDataConditionsServiceAcceptedAt),
		tap(x => {
			this.isChecked = !!x;
		})
	);
	hasError$ = this.store.pipe(select(getContractConditionsServiceHasError));
	message$ = this.store.pipe(select(getContractConditionsServiceMessage));
	text$ = this.store.pipe(select(getContractConditionsServiceText));
	textPayment$ = this.store.pipe(select(getContractConditionsPaymentText));
	isChecked = false;
	@Input() service: ServiceInfo;
	@Input() test;
	constructor(
		private store: Store<any>,
		private dialogService: DialogService,
		private contractService: ContractService
	) {}

	open() {
		this.text$
			.pipe(
				take(1),
				tap(text => {
					const dialogRef = this.dialogService.open({
						appendTo: this.containerRef,
						title: "Conditions d'abonnements",
						maxWidth: '900px',
						content: ConditionsAcceptorComponent
					});

					const conditions = dialogRef.content.instance;
					conditions.text = text;
				})
			)
			.subscribe();
	}

	openPayment() {
		let conditions = null;
		this.textPayment$
			.pipe(
				tap(text => {
					this.isChecked = false;
					if (!conditions) {
						const dialogRef = this.dialogService.open({
							appendTo: this.containerRef,
							title: 'Conditions de paiement',
							// Show component
							maxWidth: '900px',
							content: ConditionsAcceptorComponent
						});
						conditions = dialogRef.content.instance;
					}
					conditions.text = text;
				})
			)
			.subscribe();
	}
	ngOnDestroy() {
		this.store.dispatch(new ContractConditionsServiceDestroyAction(null, Date.now()));
	}

	ngOnInit() {
		this.store.dispatch(new ContractConditionsServiceInitAction(null, Date.now()));
	}

	onAccept(value) {
		if (!value) {
		} else {
			this.store.dispatch(new ContractConditionsServiceClickAcceptAction(null, Date.now()));
		}
	}
}
